export const MEDIA_ASSETS_BASE_URL = 'https://assets.hubita.co.uk/';

export const getImageUrl = (img) => {
  if (!img) return null;
  if (typeof img !== 'string') return null;
  const trimmed = img.trim();
  if (!trimmed) return null;
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://') || trimmed.startsWith('data:')) {
    return trimmed;
  }
  return `${MEDIA_ASSETS_BASE_URL}${trimmed}`;
};

export const parseDescriptionToHtml = (rawDesc) => {
  if (!rawDesc) return '<p></p>';

  let obj = rawDesc;
  if (typeof rawDesc === 'string') {
    const trimmed = rawDesc.trim();
    if (trimmed.startsWith('{') && trimmed.includes('"blocks"')) {
      try {
        obj = JSON.parse(trimmed);
      } catch (e) {
        return rawDesc;
      }
    } else {
      return rawDesc;
    }
  }

  if (obj && Array.isArray(obj.blocks)) {
    return obj.blocks
      .map((block) => {
        const text = block.text || '';
        if (!text) return '';
        return `<p style="margin-bottom: 12px; font-size: 15px; line-height: 24px; color: #374151;">${text}</p>`;
      })
      .filter(Boolean)
      .join('');
  }

  return String(rawDesc);
};

export const parseDescriptionToText = (rawDesc) => {
  if (!rawDesc) return '';

  let obj = rawDesc;
  if (typeof rawDesc === 'string') {
    const trimmed = rawDesc.trim();
    if (trimmed.startsWith('{') && trimmed.includes('"blocks"')) {
      try {
        obj = JSON.parse(trimmed);
      } catch (e) {
        return rawDesc.replace(/<[^>]*>?/gm, '').trim();
      }
    } else {
      return rawDesc.replace(/<[^>]*>?/gm, '').trim();
    }
  }

  if (obj && Array.isArray(obj.blocks)) {
    return obj.blocks
      .map((b) => b.text || '')
      .filter(Boolean)
      .join(' ')
      .trim();
  }

  return String(rawDesc).replace(/<[^>]*>?/gm, '').trim();
};
